export const withTransparency = (color: string, transparency: number) => {
  const rgbArray = color.match(/\d+/g);
  if (rgbArray) {
    return `rgba(${rgbArray.join(', ')}, ${transparency})`;
  }
  return color;
};
